import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {IDialogComponent} from "../../../../dialog/iDialog.component";
import {TagSummaryModel} from "../../model/tagSummary.model";
import {DialogWithInput} from "../../../../dialog/dialogWithInput";
import {DialogModule} from "../../../../dialog/dialog.module";
import {CardModule} from "../../../../../core/component/card/card.module";
import {TagSummaryFindAllService} from "../../service/tagSummaryFindAll.service";
import {UrlParameterBuilder} from "../../../../../core/http/UrlParameterBuilder";
import {Order, Sort} from "../../../../../../shared/utils/url.builder";
import {ServiceContainerComponent} from "../../../../../core/component/service-container/service-container.component";
import {Subscription} from "rxjs";
import {TagFieldComponent} from "../tag-field/tag-field.component";
import {FormModule} from "../../../../../form/form.module";
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  TagSaveDialogComponent,
  TagSaveDialogInput,
  TagSaveDialogOutput
} from "../tag-save-dialog/tag-save-dialog.component";
import {DialogController} from "../../../../dialog/dialogController";
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {LoadingModule} from "../../../../../../components/common/loading/loading.module";
import {
  TagSetEntityTagsActionPayload,
  TagSetEntityTagsActionService
} from "../../service/tagSetEntityTagsAction.service";
import {ActionButtonModule} from "../../../../../core/component/action-button/action-button.module";
import {
  AgendaCalendarSavePayload
} from "../../../../../agenda/modules/calendar/api/service/save/agendaCalendarSave.payload";
import {
  TagsManagementDialogComponent,
  TagsManagementDialogInput
} from "../tags-management-dialog/tags-management-dialog.component";

export interface TagsEditDialogInput {
  tags: TagSummaryModel[];
  entityTypeValue: string;
  entityId: number;
}

@Component({
  selector: 'app-tags-edit-dialog',
  templateUrl: './tags-edit-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    CardModule,
    ServiceContainerComponent,
    TagFieldComponent,
    FormsModule,
    ReactiveFormsModule,
    TagSaveDialogComponent,
    ButtonModule,
    LoadingModule,
    ActionButtonModule,
  ],
  providers: [
    TagSummaryFindAllService,
    TagSetEntityTagsActionService
  ]
})
export class TagsEditDialogComponent implements IDialogComponent<TagsEditDialogInput, void>,
  OnInit, OnDestroy {
  dialog: DialogWithInput<TagsEditDialogInput, void>;
  tags: TagsEditDialogTag[] = [];
  subscriptions: Subscription[] = [];
  formGroup: FormGroup;

  constructor(public findAllService: TagSummaryFindAllService,
              private formBuilder: FormBuilder,
              private dialogController: DialogController,
              public saveService: TagSetEntityTagsActionService) {

    this.formGroup = this.formBuilder.group({
      tagName: new FormControl(undefined),
    })
    this.findAllService.refreshOnCreated = false;
    this.findAllService.refreshOnUpdated = false;
    this.subscriptions.push(this.findAllService.entities$.subscribe(values => {
      this.tags = [];
      values.forEach(value => {
        this.tags.push({
          tag: value,
          selected: !!this.dialog.input.tags.find(value1 => value1.id === value.id)
        });
      })

    }))
  }

  ngOnInit() {
    this.refresh();
  }

  refresh() {
    this.findAllService.parameters = new UrlParameterBuilder()
        .addParameter('entityType.value', this.dialog.input.entityTypeValue)
        .parameters;
    this.findAllService.sort = new Sort('name', Order.ASCENDING);
    this.findAllService.findAll();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  close() {
    this.dialog.close(undefined);
  }

  clicked(tag: TagsEditDialogTag) {
    tag.selected = ! tag.selected;
  }

  settings() {
    const input: TagsManagementDialogInput = {
      entityTypeValue: this.dialog.input.entityTypeValue,
    }
    this.dialogController.open(TagsManagementDialogComponent, input, {
      title: 'Gestion des étiquettes',
    }).afterClosed()
        .toPromise()
        .then(() => this.refresh())
  }

  newTag() {
    const input: TagSaveDialogInput = {
      entityTypeValue: this.dialog.input.entityTypeValue,
    };
    this.dialogController.open(TagSaveDialogComponent, input, {
      title: 'Nouvelle étiquette',
      width: '400px'
    }).afterClosed()
        .toPromise()
        .then((result: TagSaveDialogOutput) => {
          if (result) {
            this.tags.push({
              tag: result.tag.summary,
              selected: true
            })
          }
        });
  }

  buildPayload = (): TagSetEntityTagsActionPayload => {
    return {
      entityTypeValue: this.dialog.input.entityTypeValue,
      entityId: this.dialog.input.entityId,
      tagIds: this.tags.filter(value => value.selected)
          .map(value => value.tag.id)
    }
  }
}

class TagsEditDialogTag {
  tag: TagSummaryModel;
  selected = false;
}
